export const POLITICAL_ISSUES = "POLITICAL_ISSUES";
export const SET_POLITICAL_ISSUES = "SET_POLITICAL_ISSUES"